import React, { useState } from 'react';
import { withRouter } from 'react-router';

import { getSectionT } from '../../i18n.js';
import { withT } from '../../context/t';
import { SectionSlugsConsumer } from '../../context/sectionSlugs';
import Link from '../Link.jsx';
import classNames from 'classnames';

const Sidemenu = props => {
  const { formFilled, sidebarDisabled, location } = props;
  const path = location.pathname;
  var activePage = path
    .split('/')
    .slice(-1)
    .pop();

  const sidebarDisabledOption = {
    'nav-vertical__link--disabled': sidebarDisabled,
  };

  return (
    <nav className="nav-vertical">
      <ul className="nav-vertical__list">
        <li className="nav-vertical__item">
          <Link
            to=""
            className={classNames('nav-vertical__link', {
              'nav-vertical__link--current': activePage === '',
            })}
            title={props.t('landing:title')}
          />
        </li>
        <SectionSlugsConsumer>
          {sectionSlugs =>
            sectionSlugs.map(sectionSlug => (
              <li className="nav-vertical__item" key={sectionSlug}>
                <Link
                  to={'section/' + sectionSlug}
                  className={classNames('nav-vertical__link', {
                    ...sidebarDisabledOption,
                    'nav-vertical__link--current': activePage === sectionSlug,
                  })}
                  title={getSectionT(sectionSlug)('title')}
                  formFilled={formFilled}
                  disabled={sidebarDisabled}
                />
              </li>
            ))
          }
        </SectionSlugsConsumer>
        <li className={`nav-vertical__item `}>
          <Link
            to={props.t('results:slug')}
            title={props.t('results:title')}
            formFilled={formFilled}
            disabled={sidebarDisabled}
            className={classNames('nav-vertical__link', {
              ...sidebarDisabledOption,
              'nav-vertical__link--current': activePage === 'results',
            })}
          />
        </li>
      </ul>
    </nav>
  );
};

const ResponsiveSidemenu = props => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="responsive-hide print-hide">
      <button
        className="responsive-hide__hint mt-4"
        onClick={() => setIsOpen(v => !v)}
      >
        <i
          className={classNames('fas', {
            'fa-caret-down': !isOpen,
            'fa-caret-up': isOpen,
          })}
        />
        {props.t('interface:menu')}
      </button>
      <div
        className={classNames('responsive-hide__content', {
          'responsive-hide__content--show': isOpen,
        })}
      >
        <Sidemenu {...props} />
      </div>
    </div>
  );
};

export default withT()(withRouter(ResponsiveSidemenu));
